import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
interface FilterState {
  accountNo: string;
  cardNo: string;
  accountType: string;
  depositType: string;
  loanType: string;
  cardType: string;
  status: string;
  fromDate: string;
  toDate: string;
  minPrice: string;
  maxPrice: string;
  loanActivityType: string;
  cardActivityType: string;
  drCr: string;
  transactionType: string;
  transactionStatus: string | null;
  accountStatus: string;
  loanStatus: string;
  cardStatus: string;
  bank: string;
  company: string;
  bankOptions: Array<string>;
  other: string;
  date: string;
  pendingTransactionStatus: null;
  requestType: null;
  payeeName: null;
  frequency: null;
  paymentType: null;
  benStatus: null;
  benBank: null;
}

const initialState: FilterState = {
  accountNo: "Account Number",
  cardNo: "Card Number",
  accountType: "Account Type",
  depositType: "Deposit Type",
  loanType: "Loan Type",
  cardType: "Card Type",
  status: "Status",
  fromDate: "",
  toDate: "",
  minPrice: "",
  maxPrice: "",
  loanActivityType: "Activity Type",
  cardActivityType: "Activity Type",
  drCr: "Dr/Cr",
  transactionType: "Transaction Type",
  transactionStatus: null,
  accountStatus: "Account Status",
  loanStatus: "Loan Status",
  cardStatus: "Card Status",
  bank: "Bank",
  company: "Company",
  bankOptions: [
    "HSBC Bank",
    "ICICI Bank",
    "SBI Bank",
    "Axis Bank",
    "Kotak Bank",
  ],
  other: "Other",
  date: "",
  pendingTransactionStatus: null,
  requestType: null,
  payeeName: null,
  frequency: null,
  paymentType: null,
  benStatus: null,
  benBank: null,
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setAccountNo: (state, action: PayloadAction<string>) => {
      state.accountNo = action.payload;
    },
    setAccountType: (state, action: PayloadAction<string>) => {
      state.accountType = action.payload;
    },
    setLoanType: (state, action: PayloadAction<string>) => {
      state.loanType = action.payload;
    },
    setCardType: (state, action: PayloadAction<string>) => {
      state.cardType = action.payload;
    },
    setTransactionType: (state, action: PayloadAction<string>) => {
      state.transactionType = action.payload;
    },
    setDrCr: (state, action: PayloadAction<string>) => {
      state.drCr = action.payload;
    },
    setAccountStatus: (state, action: PayloadAction<string>) => {
      state.accountStatus = action.payload;
    },
    setStatus: (state, action: PayloadAction<string>) => {
      state.status = action.payload;
    },
    setFromDate: (state, action: PayloadAction<string>) => {
      state.fromDate = action.payload;
    },
    setToDate: (state, action: PayloadAction<string>) => {
      state.toDate = action.payload;
    },
    setMinPrice: (state, action: PayloadAction<string>) => {
      state.minPrice = action.payload;
    },
    setMaxPrice: (state, action: PayloadAction<string>) => {
      state.maxPrice = action.payload;
    },
    setTransactionStatus: (state, action: PayloadAction<any>) => {
      state.transactionStatus = action.payload;
    },
    setBank: (state, action: PayloadAction<string>) => {
      state.bank = action.payload;
    },
    setCompany: (state, action: PayloadAction<string>) => {
      state.company = action.payload;
    },
    setDate: (state, action: PayloadAction<string>) => {
      state.date = action.payload;
    },
    setDepositType: (state, action: PayloadAction<string>) => {
      state.depositType = action.payload;
    },
    setLoanStatus: (state, action: PayloadAction<string>) => {
      state.loanStatus = action.payload;
    },
    setcardStatus: (state, action: PayloadAction<string>) => {
      state.cardStatus = action.payload;
    },
    setCardActivityType: (state, action: PayloadAction<string>) => {
      state.cardActivityType = action.payload;
    },
    setLoanActivityType: (state, action: PayloadAction<string>) => {
      state.loanActivityType = action.payload;
    },
    setCardNo: (state, action: PayloadAction<string>) => {
      state.cardNo = action.payload;
    },

    //payment dashboard filter
    setPendingTransactionStatus: (state, action: PayloadAction<any>) => {
      state.pendingTransactionStatus = action.payload;
    },
    setRequestType: (state, action) => {
      state.requestType = action.payload;
    },
    setPayeeName: (state, action) => {
      state.payeeName = action.payload;
    },
    setFrequency: (state, action) => {
      state.frequency = action.payload;
    },
    setPaymentType: (state, action) => {
      state.paymentType = action.payload;
    },
    setBenStatus: (state, action) => {
      state.benStatus = action.payload;
    },
    setBenBank: (state, action) => {
      state.benBank = action.payload;
    },
    resetFilters: (state) => {
      state.accountType = "Account Type";
      state.accountStatus = "Account Status";
      state.status = "Status";
      state.bank = "Bank";
      state.transactionType = "Transaction Type";
      state.drCr = "Dr/Cr";
      state.depositType = "Deposit Type";
      state.cardType = "Card Type";
      state.loanType = "Loan Type";
      state.accountNo = "Account Number";
      state.loanStatus = "Loan Status";
      state.loanActivityType = "Activity Type";
      state.cardActivityType = "Activity Type";
      state.cardNo = "Card Number";
      state.fromDate = "";
      state.toDate = "";
      state.minPrice = "";
      state.maxPrice = "";
      state.pendingTransactionStatus = null;
      state.payeeName = null;
      state.requestType = null;
      state.frequency = null;
      state.paymentType = null;
      state.benStatus = null;
      state.benBank = null;
    },
  },
});

export const {
  setAccountNo,
  setAccountType,
  setLoanType,
  setCardType,
  setStatus,
  setFromDate,
  setToDate,
  setMinPrice,
  setMaxPrice,
  setTransactionType,
  setDrCr,
  setAccountStatus,
  setTransactionStatus,
  setCompany,
  setBank,
  setDepositType,
  setDate,
  setLoanActivityType,
  setCardActivityType,
  setCardNo,
  resetFilters,
  setPendingTransactionStatus,
  setPayeeName,
  setRequestType,
  setFrequency,
  setPaymentType,
  setBenStatus,
  setBenBank,
} = filterSlice.actions;
export default filterSlice.reducer;
